import React, { Fragment, useState, useEffect } from "react";
import { imgCubes } from "./imageAssets";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { GetDecryptToken } from "../../helper/http-common";
import activityLogService from "../../services/ActivityLog/activity-log-service";
import { getKnackGreenRedirectUrl } from "../../utils/knackGreenUrl";

const EliteCard = () => {
  const navigate = useNavigate();
  const [userApplications, setUserApplications] = useState([]);
  const userApps = useSelector(
    (state) => state.loginReducer.loginDetials.userApplications,
  );
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (userApps?.length > 0) {
      userApps?.forEach((el) => {
        el.isHover = false;
      });
      setUserApplications(userApps);
    }
  }, [userApps]);

  //// handle card onclick
  const handleCardClick = (Id, applicationName, item) => {
    const applicationNameLower = (applicationName || "").toLowerCase();
    // For redirect cards (HRMS, Design), find the feature name from login API
    let featureName = "";
    if (Id === 6 || Id === 7 || Id === 16) {
      const selectedApp = userApps.find((app) => app.aP_Id === Id);
      if (
        selectedApp &&
        selectedApp.features &&
        selectedApp.features.length > 0
      ) {
        const matchingFeature = selectedApp.features.find((feature) => {
          const featureNameLower = feature.fT_Name.toLowerCase();
          if (Id === 6) {
            return (
              featureNameLower.includes("hrms") ||
              featureNameLower.includes("hr")
            );
          } else if (Id === 7) {
            return featureNameLower.includes("design");
          } else if (Id === 16) {
            return featureNameLower.includes("knack green");
          }
          return false;
        });
        featureName = matchingFeature
          ? matchingFeature.fT_Name
          : selectedApp.features[0].fT_Name;
      }
    }

    const activityLogPayload = {
      featureName: featureName,
      applicationName: applicationName,
    };
    activityLogService.addActivityLogsAPI(activityLogPayload).catch((error) => {
      console.log(error, "Activity Log API Error");
    });

    if (Id === 2) {
      navigate("/eliteDashboard", { state: Id });
    } else if (Id === 9) {
      navigate("/visitorHome");
    } else if (Id === 6) {
      const token = GetDecryptToken();
      const redirectUrl = `${
        process.env.REACT_APP_HRMS_URL
      }?token=${encodeURIComponent(token)}`;
      window.open(redirectUrl, "_blank");
    } else if (Id === 7) {
      const token = GetDecryptToken();
      const redirectUrl = `${
        process.env.REACT_APP_DESIGN_URL
      }?token=${encodeURIComponent(token)}`;
      window.open(redirectUrl, "_blank");
    } else if (Id === 16 || applicationNameLower.includes("knack green")) {
      const token = GetDecryptToken();
      window.open(getKnackGreenRedirectUrl(token), "_blank");
    } else if (Id === 14) {
      navigate("/MIS/Dashboard");
    } else if (
      applicationNameLower.includes("kyc") ||
      item?.aP_Name?.toLowerCase().includes("kyc")
    ) {
      navigate("/kyc");
    }
  };

  //// handle card hover base on the id
  const handleHoverCard = (id) => {
    setUserApplications((prevApplications) =>
      prevApplications.map((item) =>
        item.aP_Id === id
          ? { ...item, isHover: true }
          : { ...item, isHover: false },
      ),
    );
  };

  return (
    <Fragment>
      <div className="dashboard app-content content">
        <div className="content-wrapper">
          <div className="content-body">
            <div className="row">
              {userApplications.length > 0 &&
                userApplications.map((item) => {
                  return (
                    <div className="col-xl-3 col-lg-6 col-12" key={item.aP_Id}>
                      <div
                        className={`card card-hover cur_point ${
                          item.isHover ? "hovered" : ""
                        }`}
                        onClick={() =>
                          handleCardClick(item.aP_Id, item.aP_Name, item)
                        }
                        onMouseEnter={() => handleHoverCard(item.aP_Id)}
                        onMouseLeave={() => handleHoverCard(item.aP_Id)}
                      >
                        <div className="card-content">
                          <div className="card-body d-flex justify-content-between">
                            <img src={imgCubes} alt="img" />
                            <h4 className="text-info pt-15">{item.aP_Name}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {/* <div className="col-xl-3 col-lg-6 col-12">
                <div
                  className={`card card-hover cur_point ${
                    isEliteHovered ? "hovered" : ""
                  }`}
                  onClick={() => handleCardClick("elite")}
                  onMouseEnter={() => setIsEliteHovered(true)}
                  onMouseLeave={() => setIsEliteHovered(false)}
                >
                  <div className="card-content">
                    <div className="card-body d-flex justify-content-between">
                      <img src={imgCubes} alt="img" />
                      <h4 className="text-info pt-15">Elite</h4>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EliteCard;
